(()=>{
const root=document.querySelector('.ss[data-audience="starting-strength-training"]');
if(!root)return;
const $=selector=>root.querySelector(selector);

const features={
 guided:{image:'guided',title:'Every movement, demonstrated first.',body:"Follow a guided workout or build your own once you're ready. Nothing starts until you've seen how it's done.",note:'23.8-inch touchscreen. Every movement demonstrated before you start.',alt:'Gym Monster 3 touchscreen showing the guided workout library'},
 weights:{image:'weights',title:'Set it light. Change it any time.',body:'Set digital resistance from the screen and adjust it in 1 kg steps whenever you feel ready, no plates to load or unload.',note:'Gym Monster 3 provides up to 100 kg of digital resistance, adjustable in 1 kg steps.',alt:'Gym Monster 3 digital resistance rail with weight markings'},
 help:{image:'help',title:"Help, whenever you're training.",body:'The screen gives movement demonstrations and audio instructions any time you train. Our team is a message or a demo away for anything else.',note:'On-screen guidance, plus a personal setup session with our team.',alt:'Training at home on the Gym Monster 3'}
};
const manifest=$('#ss-feature-assets');const assets=manifest?JSON.parse(manifest.textContent):null;
const asset=(name,size)=>assets?assets[name][size]:null;
const tabs=Array.from(root.querySelectorAll('[data-feature]'));
function choose(tab,focus=false){
 const f=features[tab.dataset.feature];
 tabs.forEach(t=>{t.setAttribute('aria-selected',String(t===tab));t.tabIndex=t===tab?0:-1;});
 $('#ss-feature-panel').setAttribute('aria-labelledby',tab.id);
 const img=$('#ss-feature-image');
 img.src=asset(f.image,'1680');img.srcset=`${asset(f.image,'840')} 840w, ${asset(f.image,'1680')} 1680w`;img.alt=f.alt;
 $('#ss-feature-title').textContent=f.title;$('#ss-feature-body').textContent=f.body;$('#ss-feature-note').textContent=f.note;
 $('.ss-feature-number').textContent=`0${tabs.indexOf(tab)+1} / 03`;
 if(focus)tab.focus();
}
tabs.forEach((tab,i)=>{
 tab.addEventListener('click',()=>choose(tab));
 tab.addEventListener('keydown',event=>{const next={ArrowRight:(i+1)%tabs.length,ArrowLeft:(i+tabs.length-1)%tabs.length,Home:0,End:tabs.length-1}[event.key];if(next!==undefined){event.preventDefault();choose(tabs[next],true);}});
});

const sticky=$('.ss-mobile-action');const visible=new Map();
if('IntersectionObserver' in window){
 const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>visible.set(entry.target,entry.isIntersecting));sticky.hidden=[...visible.values()].some(Boolean);},{threshold:.05});
 [$('.ss-hero'),$('#ss-setup'),$('#ss-demo'),$('.ss-close')].forEach(section=>section&&observer.observe(section));
}

const local=['127.0.0.1','localhost'].includes(location.hostname);const abort=new AbortController();const timer=setTimeout(()=>abort.abort(),8000);
fetch(local?'/api/product/gm3':`${window.Shopify?.routes?.root||'/'}products/speediance-gym-monster-3.js`,{signal:abort.signal}).then(response=>{if(!response.ok)throw new Error('Unavailable');return response.json();}).then(product=>{
 const variant=(product.variants||[]).find(v=>v.available&&Number(v.price)>0&&(v.public_title||v.title||'').trim().toLowerCase()==='gym monster 3 / studio');
 if(!variant){return;}
 const currency=product.currency||window.Shopify?.currency?.active;
 if(!currency)return;
 const money=amount=>new Intl.NumberFormat(document.documentElement.lang||'en-AU',{style:'currency',currency,currencyDisplay:'narrowSymbol',minimumFractionDigits:0,maximumFractionDigits:0}).format(amount/100);
 const price=Number(variant.price),compareAt=Number(variant.compare_at_price||0);
 const hasSaving=compareAt>price;
 const save=hasSaving?compareAt-price:0;
 const priceText=money(price);
 const origin=local?'https://speediance.com.au':location.origin;
 const productUrl=origin+(window.Shopify?.routes?.root||'/')+`products/speediance-gym-monster-3?variant=${encodeURIComponent(variant.id)}`;

 $('#ss-price').textContent=priceText;
 if(hasSaving){
  const compareEl=$('#ss-price-compare');compareEl.textContent=money(compareAt);compareEl.hidden=false;
  const saveEl=$('#ss-price-save');saveEl.textContent=`Save ${money(save)}`;saveEl.hidden=false;
 }
 const ctaText=hasSaving?`Get Studio, save ${money(save)}`:'Explore Gym Monster 3 Studio';
 const heroCta=$('#ss-hero-cta');heroCta.textContent=ctaText;heroCta.href=productUrl;
 const productLink=$('#ss-product-link');productLink.href=productUrl;productLink.innerHTML=`${hasSaving?`Get Studio for ${priceText}`:'Explore the Studio package'} <span aria-hidden="true">→</span>`;
 const closeCta=$('#ss-close-cta');closeCta.textContent=hasSaving?`Claim the ${money(save)} saving`:ctaText;closeCta.href=productUrl;
 const weekCta=$('#ss-week-cta');if(weekCta)weekCta.href=productUrl;
 const stickyCta=$('#ss-sticky-cta');if(stickyCta){stickyCta.innerHTML=`${hasSaving?`Save ${money(save)} on Gym Monster 3 Studio`:'See the Gym Monster 3 Studio offer'} <span aria-hidden="true">→</span>`;stickyCta.href=productUrl;}
 if(variant.featured_image&&variant.featured_image.src){const productImg=$('#ss-product-image');if(productImg)productImg.src=variant.featured_image.src;}
}).catch(()=>{}).finally(()=>clearTimeout(timer));

/* Live rating, read from the GM3 product page's own Loox markup */
if(!local){
 const ratingAbort=new AbortController();const ratingTimer=setTimeout(()=>ratingAbort.abort(),8000);
 fetch(`${window.Shopify?.routes?.root||'/'}products/speediance-gym-monster-3`,{signal:ratingAbort.signal}).then(r=>{if(!r.ok)throw new Error('unavailable');return r.text();}).then(html=>{
  const ratingMatch=html.match(/data-rating="([\d.]+)"/);
  const ratersMatch=html.match(/data-raters="(\d+)"/);
  if(!ratingMatch||!ratersMatch)return;
  const rating=ratingMatch[1];
  const raters=Math.floor(Number(ratersMatch[1])/100)*100;
  if(!raters)return;
  const ratingEl=$('#ss-rating'),textEl=$('#ss-rating-text');
  if(ratingEl&&textEl){textEl.textContent=`Rated ${rating} by ${raters.toLocaleString('en-AU')}+ Speediance owners`;ratingEl.hidden=false;}
 }).catch(()=>{}).finally(()=>clearTimeout(ratingTimer));
}
})();
